import {Component, NgZone, ViewChild} from '@angular/core';
import {CalendarComponent as FullCalendarComponent} from "ap-angular2-fullcalendar";
import {ReservationEventModalComponent} from "./modals/reservation-event-modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CreateDisposalModalComponent} from "./modals/create-disposal-modal.component";
import {NotificationsService} from "../../../services/notifications.service";
import {EventsService, EventType} from "../../../services/events.service";
import {SimpleDate} from "../../../utils/simple-date";
import {RemoveDisposalModalComponent} from "./modals/remove-disposal-modal.component";
import {CalendarEvent} from "./calendar-event";

function isMobile() {
  return window.innerWidth < 400;
}

@Component({
  selector: 'calendar',
  templateUrl: 'calendar.component.html'
})
export class CalendarComponent {
  @ViewChild(FullCalendarComponent) fullCalendar: FullCalendarComponent;

  calendarOptions: any = {
    locale: 'pl',
    selectable: true,
    timezone: 'local',
    timeFormat: 'HH:mm',
    height: isMobile() ? 500 : null,
    header: isMobile() ? {
      left: 'title',
      center: '',
      right: 'prev,next'
    } : null,
    longPressDelay: 250,
    events: (start, end, timezone, callback) => this.zone.run(() => this.fetchEvents(start.toDate(), end.toDate(), callback)),
    eventClick: (event: CalendarEvent) => this.zone.run(() => this.handleEventClick(event)),
    select: (start, end) => this.zone.run(() => {
      this.handleSelect(start.toDate(), end.subtract(1, 'day').endOf('day').toDate())
    }),
  };

  constructor(private eventsService: EventsService, private modalService: NgbModal, private zone: NgZone, private notificationsService: NotificationsService) {
  }

  private fetchEvents(start: Date, end: Date, updateCallback: any) {
    this.eventsService
      .getEvents(new SimpleDate(start), new SimpleDate(end))
      .map(events => events.map(event => new CalendarEvent(event)))
      .subscribe(events => updateCallback(events));
  }

  private handleEventClick(calendarEvent: CalendarEvent) {
    if (calendarEvent.originalEvent.type == EventType.RESERVATION_CONFIRMED || calendarEvent.originalEvent.type == EventType.RESERVATION_WAITING) {
      ReservationEventModalComponent.open(this.modalService, calendarEvent.originalEvent.origin_id);
    } else {
      RemoveDisposalModalComponent.open(this.modalService, calendarEvent).subscribe(
        (result) => {
          if (result) {
            this.fullCalendar.fullCalendar('refetchEvents');
            this.notificationsService.show('Dyspozycja została usunięta.')
          }
        }
      );
    }
  }

  private handleSelect(start: Date, end: Date) {
    CreateDisposalModalComponent.open(this.modalService, new SimpleDate(start), new SimpleDate(end))
      .subscribe(
        confirm => {
          this.fullCalendar.fullCalendar('unselect');
          if (confirm) {
            this.fullCalendar.fullCalendar('refetchEvents');
            this.notificationsService.show('Dyspozycja została utworzona.')
          }
        },
        _ => this.fullCalendar.fullCalendar('unselect'),
      );
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/calendar/calendar.component.ts